var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14.3 14.3"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3806",
    fill: "none",
    stroke: "#ff4242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18907",
    d: "M7.15.65a6.5 6.5 0 1 1-6.5 6.5 6.5 6.5 0 0 1 6.5-6.5Z",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18908",
    d: "M7.151 4.477v3.108",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18909",
    d: "M7.146 9.821h.005",
    strokeWidth: 1.6
  }))));
};
export default SvgInfo;